<div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Detalhes da venda: Número {{sale.id}}</h1>
    </div>
  </div>

<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form class="space-y-6">
    <p-tabs value="0">
      <p-tablist>
          <p-tab value="0"><i class="pi pi-box"></i>Principal</p-tab>
          <p-tab value="1"><i class="pi pi-shop"></i>Produtos</p-tab>
      </p-tablist>
      <p-tabpanels>
      <p-tabpanel value="0">  
        
        <p-fieldset legend="Geral">
            <p class="m-0">
                <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          
            <div>
            <label class="block mb-1 font-medium">Data da Venda</label>
            <input
              pInputText
              
              name="date"
              [value]="sale.date | date:'dd/MM/yyyy hh:mm:ss'"
              readonly
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Status</label>
            <input
              pInputText
              readonly
              name="status"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Celular</label>
            <input
              pInputText
              readonly
              [value]="sale.phone"
              name="phone"
              class="w-full"
            />
          </div>

          <div class="col-span-2">
            <label class="block mb-1 font-medium">Cliente</label>
            <input
              pInputText
              readonly
              [value]="sale.customerName"
              name="customer"
              class="w-full"
            />
          </div>
        </div> 

        <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          
            <div>
                <label class="block mb-1 font-medium">Desconto</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.discount"
                    readonly
                    class="w-full"
                    name="discount"
                />
            </div>

            <div>
                <label class="block mb-1 font-medium">Total Bruto</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.grossTotal"
                    readonly
                    class="w-full"
                    name="grossTotal"
                />
            </div>

            <div>
                <label class="block mb-1 font-medium">Total</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.netTotal"
                    readonly
                    class="w-full"
                    name="netTotal"
                />
            </div>

            <div class="col-span-2">
                <label class="block mb-1 font-medium">Vendedor</label>
                <input
                    [(ngModel)]="sale.employee.fullName"
                    pInputText
                    readonly
                    name="seller"
                    class="w-full"
                    />
            </div>

        </div>
        </p-fieldset>
        


        <p-fieldset legend="Pagamento">
            <div class="grid grid-cols-1 md:grid-cols-6 gap-6">

            <div>
                <label class="block mb-1 font-medium">Dinheiro</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.moneyTotal"
                    class="w-full"
                    name="money"
                    readonly
                />
            </div>

            <div>
                <label class="block mb-1 font-medium">Pix</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.pixTotal"
                    readonly
                    class="w-full"
                    name="pix"
                />
            </div>

            <div>
                <label class="block mb-1 font-medium">Débito</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.debitCardTotal"
                    readonly
                    class="w-full"
                    name="debit"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Crédito</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.creditCardTotal"
                    readonly
                    class="w-full"
                    name="creditCard"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Crediário</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.creditTotal"
                    readonly
                    class="w-full"
                    name="credit"
                />
            </div>
            <!-- <div>
                <label class="block mb-1 font-medium">Ted/Doc</label>
                <input
                pInputText
                
                name="date"
                [(ngModel)]="sale."
                class="w-full"
                />
            </div> -->
        </div> 

        <div class="grid grid-cols-1 md:grid-cols-6 gap-6">
          
            <div>
                <label class="block mb-1 font-medium">Depósito</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.depositTotal"
                    readonly
                    class="w-full"
                    name="deposit"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Cheque</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.checkTotal"
                    readonly
                    class="w-full"
                    name="check"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Vale</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.voucherTotal"
                    readonly
                    class="w-full"
                    name="voucher"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Cashback</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.cashBackTotal"
                    readonly
                    class="w-full"
                    name="cashback"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Total a Pagar</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.netTotal"
                    readonly
                    class="w-full"
                    name="net"
                />
            </div>
            <div>
                <label class="block mb-1 font-medium">Troco</label>
                <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    readonly
                    [inputStyle]="{ width: '100%' }"
                    [(ngModel)]="sale.exchange"
                    class="w-full"
                    name="exchange"
                />
            </div>

            </div>
        </p-fieldset>
        </p-tabpanel>

        <p-tabpanel value="1">
        
            <app-list-produt-in-sale-form [saleId]="sale.id" [itens]="sale.saleItems"/>
        
        </p-tabpanel>

    </p-tabpanels>
</p-tabs>

 <!-- Botões -->
    <div class="flex justify-end gap-3">
      <button (click)="goBack()" type="button" class="border px-2 py-2 border-orange-500 cursor-pointer rounded">Voltar</button>
    </div>
  </form>
</div>